import * as React from 'react'
import { FilterProps, Filter } from 'react-admin'
import { PayoutPerClinicListFiltersArray } from './Filters'

const PayoutPerClinicFilter: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {PayoutPerClinicListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default PayoutPerClinicFilter
